import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, normalizeClass as _normalizeClass, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/images/logo.png'


const _hoisted_1 = {
  class: "topbar",
  "aria-label": "Hauptnavigation"
}
const _hoisted_2 = {
  class: "desktop-nav",
  "aria-label": "Seitennavigation"
}
const _hoisted_3 = ["aria-expanded"]
const _hoisted_4 = ["aria-hidden"]
const _hoisted_5 = { class: "sidebar-header" }
const _hoisted_6 = {
  class: "sidebar-links",
  "aria-label": "Seitenmenü"
}

import { Briefcase, BriefcaseBusiness, Contact, Home, Info, Menu, Wrench, X } from "lucide-vue-next";
import { ref } from "vue";

import "@/assets/styles/sidebar.css";


export default /*@__PURE__*/_defineComponent({
  __name: 'SidebarComponent',
  setup(__props) {

const isOpen = ref(false);
const closeSidebar = () => (isOpen.value = false);

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("header", _hoisted_1, [
      _createVNode(_component_RouterLink, {
        to: "/",
        class: "brand",
        "aria-label": "Dachdecker Beispiel – Startseite"
      }, {
        default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
          _createElementVNode("img", {
            src: _imports_0,
            alt: "",
            class: "brand-logo"
          }, null, -1),
          _createElementVNode("div", { class: "brand-text" }, [
            _createElementVNode("strong", null, "Dachdecker Beispiel"),
            _createElementVNode("span", null, "Meisterbetrieb für Mannheim & Region")
          ], -1)
        ]))]),
        _: 1
      }),
      _createElementVNode("nav", _hoisted_2, [
        _createVNode(_component_RouterLink, { to: "/" }, {
          default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
            _createTextVNode("Start", -1)
          ]))]),
          _: 1
        }),
        _createVNode(_component_RouterLink, { to: "/ueber" }, {
          default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
            _createTextVNode("Über uns", -1)
          ]))]),
          _: 1
        }),
        _createVNode(_component_RouterLink, { to: "/leistungen" }, {
          default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
            _createTextVNode("Leistungen", -1)
          ]))]),
          _: 1
        }),
        _createVNode(_component_RouterLink, { to: "/referenzen" }, {
          default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
            _createTextVNode("Referenzen", -1)
          ]))]),
          _: 1
        }),
        _createVNode(_component_RouterLink, { to: "/karriere" }, {
          default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
            _createTextVNode("Karriere", -1)
          ]))]),
          _: 1
        }),
        _createVNode(_component_RouterLink, {
          to: "/kontakt",
          class: "nav-cta"
        }, {
          default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
            _createTextVNode("Angebot anfragen", -1)
          ]))]),
          _: 1
        })
      ]),
      _createElementVNode("button", {
        class: "menu-btn",
        type: "button",
        "aria-label": "Seitenmenü öffnen",
        "aria-expanded": isOpen.value,
        onClick: _cache[0] || (_cache[0] = ($event: any) => (isOpen.value = true))
      }, [
        _createVNode(_unref(Menu))
      ], 8, _hoisted_3)
    ]),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (isOpen.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "sidebar-overlay",
              onClick: closeSidebar
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createElementVNode("aside", {
      class: _normalizeClass(["sidebar", { open: isOpen.value }]),
      "aria-hidden": !isOpen.value
    }, [
      _createElementVNode("div", _hoisted_5, [
        _cache[8] || (_cache[8] = _createElementVNode("div", null, [
          _createElementVNode("span", { class: "drawer-kicker" }, "Schnellzugriff"),
          _createElementVNode("h2", null, "Wohin dürfen wir Sie führen?")
        ], -1)),
        _createElementVNode("button", {
          class: "close-btn",
          type: "button",
          "aria-label": "Seitenmenü schließen",
          onClick: closeSidebar
        }, [
          _createVNode(_unref(X))
        ])
      ]),
      _createElementVNode("nav", _hoisted_6, [
        _createVNode(_component_RouterLink, {
          to: "/",
          class: "points-link",
          onClick: closeSidebar
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(Home)),
            _cache[9] || (_cache[9] = _createTextVNode("Startseite", -1))
          ]),
          _: 1
        }),
        _createVNode(_component_RouterLink, {
          to: "/ueber",
          class: "points-link",
          onClick: closeSidebar
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(Info)),
            _cache[10] || (_cache[10] = _createTextVNode("Über uns", -1))
          ]),
          _: 1
        }),
        _createVNode(_component_RouterLink, {
          to: "/leistungen",
          class: "points-link",
          onClick: closeSidebar
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(Wrench)),
            _cache[11] || (_cache[11] = _createTextVNode("Leistungen", -1))
          ]),
          _: 1
        }),
        _createVNode(_component_RouterLink, {
          to: "/referenzen",
          class: "points-link",
          onClick: closeSidebar
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(Briefcase)),
            _cache[12] || (_cache[12] = _createTextVNode("Referenzen", -1))
          ]),
          _: 1
        }),
        _createVNode(_component_RouterLink, {
          to: "/karriere",
          class: "points-link",
          onClick: closeSidebar
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(BriefcaseBusiness)),
            _cache[13] || (_cache[13] = _createTextVNode("Karriere", -1))
          ]),
          _: 1
        }),
        _createVNode(_component_RouterLink, {
          to: "/kontakt",
          class: "points-link",
          onClick: closeSidebar
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(Contact)),
            _cache[14] || (_cache[14] = _createTextVNode("Kontakt & Angebot", -1))
          ]),
          _: 1
        })
      ]),
      _cache[15] || (_cache[15] = _createElementVNode("div", { class: "sidebar-contact" }, [
        _createElementVNode("span", null, "Direkt erreichbar"),
        _createElementVNode("a", { href: "tel:+49123456789" }, "+49 123 456789"),
        _createElementVNode("small", null, "Mo–Fr, 07:00–17:00 Uhr")
      ], -1))
    ], 10, _hoisted_4)
  ], 64))
}
}

})